import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class MeService extends ApiService {
  constructor() {
    super();
    this.url = 'me';
  }

  getCurrentUserDetails(): Observable<User> {
    return this.get<User>();
  }
}
